<template>
  <FormSelect
    :id="id"
    :label="label"
    :required="required"
    :value="value"
    @change="$emit('change', $event)"
    @input="$emit('input', $event)"
  >
    <template #default>
      <option :value="null"></option>
      <option :value="country[0]" v-for="country in countries">
        {{ country[1].name }}
      </option>
    </template>

    <template #help><slot name="help" /></template>
    <template #error><slot name="error" /></template>
  </FormSelect>
</template>

<script>
  import { countries } from 'countries-list';
  import FormSelect from '@/components/Form/FormSelect.vue';

  export default {
    name: 'FormCountrySelect',
    components: { FormSelect },
    props: {
      id: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
        default: 'Choisir un pays',
      },
      value: {
        type: String,
        required: false,
        default: null,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      countries() {
        return Object.entries(countries);
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
